import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getDeviceInteraction } from '@gameday/utils/selectors/getDeviceInteraction';
import {
    InnerWrapper,
    CustomPlayerCellContainer,
    PositionWrapper,
    PlayerLink,
    OrderWrapper
} from '../LineupMatchup.style';
import useTracking from '@gameday/utils/hooks/useTracking';
import { getContextData } from '@gameday/utils/selectors/getContextData';
import buildPlayerUrl from '@gameday/utils/buildPlayerUrl';
import { getLanguage } from '@gameday/utils/selectors/getLanguage';

const CustomPlayerCell = (props) => {
    const Tracking = useTracking();
    const { deviceInteraction } = useSelector(getDeviceInteraction);
    const { data = {} } = props;
    const { position, name, order, playerId, componentName } = data;
    const getPlayerContextData = useSelector(getContextData);
    const { disablePlayerLinks, playerPageContext } = getPlayerContextData(playerId);
    const language = useSelector(getLanguage);
    const playerUrl = buildPlayerUrl({ nameSlug: playerId, language, playerPageContext });
    const handlePlayerPage = useCallback((e) => {
        const text = e?.target.innerText;
        const playerId = e?.currentTarget?.dataset?.playerid;

        const cfg = {
            componentName: ['Preview', componentName],
            text,
            activity: 'Player Link Click'
        };

        Tracking.track.track_click(cfg);

        if (deviceInteraction.playercard({ title: 'Player Card', url: playerUrl, pid: playerId })) {
            e.preventDefault();
            return false;
        }
    }, [deviceInteraction, playerUrl, playerId]);

    const handlers = useMemo(() => ({
        onClick: handlePlayerPage
    }), [handlePlayerPage]);

    return (
        <CustomPlayerCellContainer>
            <InnerWrapper >
                {order && <OrderWrapper>{order}</OrderWrapper>}
                {!disablePlayerLinks
                    ? (
                        <PlayerLink
                            url={playerUrl}
                            target={'_blank'}
                            ariaLabel={name}
                            handlers={handlers}
                            dataAttr={{ 'data-playerid': playerId }}
                        >
                            {name}
                        </PlayerLink>
                    )
                    : (
                        name
                    )}
            </InnerWrapper>
            <PositionWrapper>{position}</PositionWrapper>
        </CustomPlayerCellContainer>
    );
};

CustomPlayerCell.propTypes = {
    data: PropTypes.shape({
        displayPositions: PropTypes.string,
        playerUrl: PropTypes.string,
        playerFullName: PropTypes.string,
        note: PropTypes.string,
        player: PropTypes.string,
        isSubstitute: PropTypes.bool,
        type: PropTypes.string,
        playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
};

export default CustomPlayerCell;
